import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M2.05 11h4.967c.14-3.991 1.104-6.628 2.128-8.318.069-.114.138-.223.206-.327A10.008 10.008 0 0 0 2.05 11ZM12 2.266c-.305.287-.72.752-1.145 1.452-.82 1.354-1.7 3.63-1.837 7.282h5.963c-.137-3.653-1.016-5.928-1.836-7.282A6.905 6.905 0 0 0 12 2.266ZM14.982 13H9.018c.138 3.652 1.017 5.928 1.837 7.282.424.7.84 1.165 1.145 1.452.305-.287.72-.752 1.145-1.452.82-1.354 1.7-3.63 1.837-7.282Zm-5.63 8.645a10.51 10.51 0 0 1-.207-.327C8.12 19.628 7.156 16.991 7.017 13H2.05a10.008 10.008 0 0 0 7.302 8.645Zm5.297 0c.069-.104.137-.213.206-.327 1.024-1.69 1.989-4.327 2.128-8.318h4.968a10.008 10.008 0 0 1-7.302 8.645ZM21.95 11h-4.968c-.14-3.991-1.104-6.628-2.128-8.318a10.609 10.609 0 0 0-.206-.327A10.008 10.008 0 0 1 21.95 11ZM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
